export default "__VITE_ASSET__B_Imo2Kh__"